// import CompetenceForm from "#competence/components/competence/CompetenceForm"
import AddIcon from "@mui/icons-material/Add"
import { Button } from "@mui/material"
import MUIDataTable from "mui-datatables"
import { Fragment, useState } from "react"
import ChipStatus from "../ChipStatus"
import CompetenceForm from "./CompetenceForm"
export default function CompetenceTable({ data, onClick }) {
	const [open, setOpen] = useState(false)
	const columns = [
		{
			name: "name",
			label: "Nombre",
			options: {
				filter: false,
				sort: true,
			},
		},
		{
			name: "category_name",
			label: "Categoría ",
			options: {
				filter: false,
				sort: true,
			},
		},
		{
			name: "description",
			label: "Descripción",
			options: {
				filter: true,
				sort: false,
			},
		},
		{
			name: "active",
			label: "Activo",
			options: {
				filter: true,
				sort: false,
				customBodyRender: (value) => {
					return <ChipStatus active={value} />
				},
			},
		},
	]
	const onRowClick = (rowData, { dataIndex }) => {
		if (onClick && typeof onClick === "function") onClick(data[dataIndex])
	}
	const options = {
		filter: false,
		download: false,
		print: false,
		viewColumns: false,
		onRowClick,
		selectableRows: "none",
		textLabels: {
			body: {
				noMatch: "No hay Competencias",
			},
		},

		customToolbar: () => (
			<Button color="primary" startIcon={<AddIcon />} onClick={() => setOpen(true)}>
				Agregar Competencia
			</Button>
		),
	}

	return (
		<Fragment>
			<MUIDataTable
				title={"Competencias"}
				data={data || []}
				columns={columns}
				options={options}
			/>
			<CompetenceForm {...{ open, setOpen }} />
			{/* 
			<CompetenceInfoDialog {...{ open: openInfo, setOpen: setOpenInfo, id: select }} /> */}
		</Fragment>
	)
}
